ViewAll<template>
  <div class="justify-end mt-5 flex">
    <p
      class="
        inline-block
        text-gray-500
        font-AvenirBlackFont
        hover:underline
        cursor-pointer
        uppercase
        text-sm
        sm:text-md
      "
      @click="handleClick"
    >
      View all videos
    </p>
    <img class="h-2 w-3 ml-2 my-auto" :src="getImg()" alt="arrows" />
  </div>
</template>

<script>
import { generateFullPath } from "../utils/fileHelpers";

export default {
  name: "ViewAll",

  methods: {
    handleClick() {
      this.$router.push({
        name: "VideosPage",
        params: { id: 1 },
      });
    },

    getImg() {
      return generateFullPath("/img/arrows.png");
    },
  },
};
</script>

